import { IsBoolean, IsNumber, IsString } from 'class-validator';

/**
 * What an operator sends to confirm or dismiss an IoT-written suggestion
 * (real-time breach, cumulative-risk, or the nightly rollup's out-of-range
 * day): the temperature they measured by hand and the outcome they declare
 * for it. Always produces a normal signed human record — the suggestion
 * itself is never rewritten into a register fact, only annotated.
 *
 * `isCompliant` is the operator's own DECLARATION, never the source of
 * truth: the server always recalculates compliance from `temperature`
 * against the equipment's range (same rule the ordinary signing path
 * already follows) and that calculation — not this field — is what the
 * human record's `data.isCompliant` ends up holding. The declaration is
 * preserved verbatim in `data.declaredCompliant` for the dossier: a
 * mismatch between what the operator declared and what the number says is
 * information for an inspector, never an error to silently overwrite.
 */
export class ReviewIotSuggestionDto {
  @IsNumber()
  temperature!: number;

  @IsBoolean()
  isCompliant!: boolean;

  @IsString()
  signatureImage!: string;
}
